<template>
  <div class="login-view">
    <div class="login-container">
      <div class="login-header">
        <i class="fas fa-comments logo-icon"></i>
        <h1>WondaCRM</h1>
      </div>
      
      <form @submit.prevent="login" class="login-form">
        <div class="form-group">
          <label for="login">Логин</label>
          <input 
            type="text" 
            id="login" 
            v-model="loginValue" 
            required 
            placeholder="Введите логин"
            class="form-control"
          />
        </div>
        
        <div class="form-group">
          <label for="password">Пароль</label>
          <div class="password-input">
            <input 
              :type="showPassword ? 'text' : 'password'" 
              id="password" 
              v-model="password" 
              required 
              placeholder="Введите пароль"
              class="form-control"
            />
            <button 
              type="button" 
              @click="togglePasswordVisibility" 
              class="toggle-password"
            >
              <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            </button>
          </div>
        </div>
        
        <div v-if="error" class="error-message">
          {{ error }}
        </div>
        
        <button type="submit" class="login-button" :disabled="loading">
          <span v-if="loading">
            <i class="fas fa-spinner fa-spin"></i> Вход...
          </span>
          <span v-else>Войти</span>
        </button>
      </form>
      
      <div class="login-footer">
        <p>Для получения доступа обратитесь к администратору</p>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export default {
  name: 'LoginView',
  setup() {
    const store = useStore();
    const router = useRouter();
    
    const loginValue = ref('');
    const password = ref('');
    const showPassword = ref(false);
    const loading = ref(false);
    const error = ref('');
    
    const togglePasswordVisibility = () => {
      showPassword.value = !showPassword.value;
    };
    
    const login = async () => {
      loading.value = true;
      error.value = '';
      
      try {
        await store.dispatch('login', {
          login: loginValue.value,
          password: password.value
        });
        
        router.push('/');
      } catch (err) {
        console.error('Ошибка при входе:', err);
        error.value = err.response?.data?.error || 'Ошибка при входе. Проверьте логин и пароль.';
      } finally {
        loading.value = false;
      }
    };
    
    return {
      loginValue,
      password,
      showPassword,
      loading,
      error,
      togglePasswordVisibility,
      login
    };
  }
};
</script>

<style scoped>
.login-view {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background-color: #f5f5f5;
}

.login-container {
  width: 100%;
  max-width: 400px;
  padding: 30px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.logo-icon {
  font-size: 48px;
  color: #2196f3;
  margin-bottom: 15px;
}

h1 {
  font-size: 24px;
  color: #333;
}

.login-form {
  display: flex;
  flex-direction: column;
}

.form-group {
  margin-bottom: 20px;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
  color: #333;
}

.form-control {
  width: 100%;
  padding: 10px 15px;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  font-size: 14px;
}

.password-input {
  position: relative;
}

.toggle-password {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #707579;
  cursor: pointer;
}

.error-message {
  color: #f44336;
  margin-bottom: 15px;
  font-size: 14px;
}

.login-button {
  padding: 12px;
  background-color: #2196f3;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.login-button:hover {
  background-color: #1976d2;
}

.login-button:disabled {
  background-color: #90caf9;
  cursor: not-allowed;
}

.login-footer {
  margin-top: 20px;
  text-align: center;
  font-size: 14px;
  color: #707579;
}
</style> 